import { set, toggle } from "@/utils/vuex";

export default {
  setCreds: set("creds"),
  setSession: set("session"),
  setCodeChallenge: set("codeChallenge"),
  setSessionExpiration: set("sessionExpiration"),
  setImpBrokerage: set("impBrokerage"),
  setImpUser: set("impUser"),
  setImpLoanOffice: set("impLoanOffice"),
  setToggleIsReAuthing: set("isReAuthing"),
  setSessionAutoRefresh: set("sessionAutoRefresh"),
  toggleIsAuthing: toggle("isAuthing"),
  // toggleIsReAuthing: toggle("isReAuthing"),
  toggleIsAuthingBroker: toggle("isAuthingBroker"),
};
